import { render, staticRenderFns } from "./ProfitAndLossReport.vue?vue&type=template&id=36045b9f&"
import script from "./ProfitAndLossReport.vue?vue&type=script&lang=js&"
export * from "./ProfitAndLossReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports